import { gql } from '@apollo/client';
import { ActivitySeasonType } from '../../../models/season';
import { GqlSimpleTag } from './tag';

export interface GqlSeason {
  id: number;
  country: string;
  name: string;
  programId: number;
  startDate: string;
  endDate: string;
  sportId: number;
  timezone: string;
  zipCode: string;
  tsDivisionId: string;
  isArchived: boolean;
  type: ActivitySeasonType;
  areaOfOperation: GqlSimpleTag;
  defaultPaymentAccountId: number;
}

export const GqlSeasonFragment = gql`
  fragment SeasonFields on Season {
    __typename
    id
    country
    name
    type
    programId
    startDate
    endDate
    sportId
    timezone
    zipCode
    tsDivisionId
    isArchived
    defaultPaymentAccountId
    areaOfOperation {
      id
      name
    }
  }
`;
